module.exports = __webpack_public_path__ + "static/media/PerformanceStats.8eb36175.png";